import React, { PropsWithChildren } from "react";
import { Modal } from "react-bootstrap";
import { CloseButton, Header, StyledModal } from "./styles";

interface ModalWrapperProps {
  children: any;
  isOpen: boolean;
  onClose: () => void;
  title: string;
  maxwidth?: string;
  overflowVisible?: boolean;
}

export const CustomModal = ({
  children,
  isOpen,
  onClose,
  title,
  maxwidth,
  overflowVisible
}: PropsWithChildren<ModalWrapperProps>): JSX.Element => {
  return (
    <StyledModal
      show={isOpen}
      onHide={onClose}
      maxwidth={maxwidth}
      backdrop="static"
      centered
      scrollable
      overflowVisible={overflowVisible}
    >
      <Header>
        <span>{title}</span>
        <CloseButton aria-label="close" onClick={onClose} />
      </Header>
      <Modal.Body>
        {children}
      </Modal.Body>
    </StyledModal>
  );
};
